import * as yup from 'yup'

export const registerValidationSchema = yup.object().shape({
  firstName: yup.string().required('This field is required'),
  lastName: yup.string().required('This field is required'),
  email: yup.string().required('This field is required'),
  password: yup.string().required('This field is required'),
  confirmPassword: yup.string().oneOf([yup.ref('password')], 'Passwords must match'),
})

export type RegisterSchemaType = {
  firstName: string
  lastName: string
  companyName: string
  email: string
  password: string
  confirmPassword: string
  dob: string
  phone: string
  authMethod: number
  deviceType: number
  deviceToken: string
  authToken: string
}

export const registerInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  companyName: '',
  dob: '',
  password: '',
  confirmPassword: '',
  phone: '',
  authMethod: 0,
  deviceType: 0,
  deviceToken: '',
  authToken: '',
}
